import { render } from "./HelpMaterial.vue?vue&type=template&id=df7812f2"
import script from "./HelpMaterial.vue?vue&type=script&lang=js"
export * from "./HelpMaterial.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__